/** biome-ignore-all lint/correctness/useExhaustiveDependencies: TODO: fix */

import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Col, Form, Row } from 'antd';

import { useGetTMSSettings } from '@/modules/settings';

import { getCargoSpecificShipmentAccessorialsInProgress } from '../../../../../../redux/shipment/ShipmentActions';
import { trimObjectValues } from '../../../../../../utilz';
import { routeFileSelector } from '../../../../../../utilz/i18n';
import FormDatePicker from '../../../../../components/Inputs/FormDatePicker';
import { CargoTypeSelect, ShipmentBranchSelect, ShipmentTermsSelect, ShipmentTypeSelect } from '../../selects';

const TransportationProviderSearchForm = () => {
  const dispatch = useDispatch();
  const { selectedCompany } = useSelector((state) => state.auth);
  const [form] = Form.useForm();
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const { data: TMSSettings } = useGetTMSSettings({
    customerKey: selectedCompany?.companyId,
  });

  useEffect(() => {
    if (TMSSettings?.shipmentSettings) {
      form.setFieldsValue({
        branch: TMSSettings?.shipmentSettings?.defaultBranchKey,
        shipmentTerms: TMSSettings?.shipmentSettings?.defaultShipmentTerms,
        shipmentType: TMSSettings?.shipmentSettings?.defaultShipmentType,
      });
    }
  }, [form, TMSSettings?.shipmentSettings]);

  const cargoType = Form.useWatch('cargoType', form);

  const fetchCargoSpecificAccessorials = useCallback(() => {
    if (cargoType) {
      const payload = {
        cargoType: cargoType.join(','),
        shipmentKey: 0,
      };
      dispatch(getCargoSpecificShipmentAccessorialsInProgress(payload));
    }
  }, [cargoType, dispatch]);

  useEffect(() => {
    fetchCargoSpecificAccessorials();
  }, [cargoType, fetchCargoSpecificAccessorials]);

  return (
    <Form
      form={form}
      name="transportationProviderSearchForm"
      initialValues={trimObjectValues({
        branch: TMSSettings?.shipmentSettings?.defaultBranchKey,
        cargoType: [],
        shipmentTerms: TMSSettings?.shipmentSettings?.defaultShipmentTerms,
        shipmentType: TMSSettings?.shipmentSettings?.defaultShipmentType,
      })}
    >
      <Row gutter={30}>
        <Col className="w-20">
          <ShipmentTypeSelect
            name="shipmentType"
            margin="mb-12"
            rules={[
              {
                message: t('translation:default.fields.shipmentType.label'),
                required: true,
              },
            ]}
          />
          <CargoTypeSelect
            label={t('translation:default.fields.cargoType.label')}
            placeholder={t('translation:default.fields.cargoType.placeholder')}
            name="cargoType"
            mode="multiple"
            disableDefaultOptions
          />
        </Col>
        <Col className="w-20">
          <FormDatePicker
            name="shipDate"
            label={t('translation:default.fields.shipDate.label')}
            margin="m-0"
            rules={[
              {
                message: t('translation:default.fields.shipDate.message'),
                required: true,
              },
            ]}
          />
        </Col>
        <Col className="w-20">
          <FormDatePicker
            name="deliveryDate"
            label={t('translation:default.fields.deliveryDate.label')}
            margin="m-0"
            rules={[
              {
                message: t('translation:default.fields.deliveryDate.message'),
                required: true,
              },
            ]}
          />
        </Col>
        <Col className="w-20">
          <ShipmentTermsSelect
            name="shipmentTerms"
            margin="m-0"
            rules={[
              {
                message: t('translation:default.fields.shipmentTerms.message'),
                required: true,
              },
            ]}
          />
        </Col>
        <Col className="w-20">
          <ShipmentBranchSelect
            name="branch"
            margin="m-0"
            customerId={selectedCompany?.companyId}
            rules={[
              {
                message: t('translation:default.fields.shipmentBranch.message'),
                required: true,
              },
            ]}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default TransportationProviderSearchForm;
